import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
import { cn } from '@/shadcn-ui/utils';

export default function XFormerlyTwitter({
  className,
  fillPrimary = colors.neutral60,
  hoverFillPrimary = 'group-hover:fill-flexcar-neutral1',
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('group h-[16px] w-[16px]', className)}
    >
      <path
        d="M12.2176 1.26953H14.4666L9.55323 6.88519L15.3334 14.5268H10.8076L7.26277 9.89222L3.20671 14.5268H0.956369L6.2117 8.52026L0.666748 1.26953H5.30749L8.51168 5.50575L12.2176 1.26953ZM11.4283 13.1807H12.6745L4.63034 2.54495H3.29306L11.4283 13.1807Z"
        fill={fillPrimary}
        className={hoverFillPrimary}
      />
    </svg>
  );
}
